import React, { Component } from 'react';

const withExtraProps = (getExtraProps) => (WrappedComponent) => {
  class WithExtraPropsComponent extends Component {
    render() {
      const finalProps = {
        ...getExtraProps(this.props),
        ...this.props
      };
      return <WrappedComponent {...finalProps} />;
    }
  }

  const wrappedName =
    WrappedComponent.displayName || WrappedComponent.name || 'Component';
  WithExtraPropsComponent.displayName = `WithExtraProps(${wrappedName})`;

  return WithExtraPropsComponent;
};

export default withExtraProps;
